import React from "react";

const SurveyFormCsdNumber = ({ csdNumber, csdNumberRef, onCsdNumberChange}) => {
  return (
    <div className="grid grid-cols-10 gap-2 pt-0 p-2 mb-2 pb-2 text-center max-w-[700px] print:m-auto">
      <div className="col-span-7"></div>
      <div className="col-span-3">
        <span className="text-xs font-bold">CSD Number</span>
        <input
          ref={csdNumberRef}
          type="text"
          value={csdNumber}
          onChange={(e) => onCsdNumberChange(e.target.value)}
          className="w-full p-2 border rounded text-center"
        />
      </div>
    </div>
  );
};

export default SurveyFormCsdNumber;
